import { MegaMenu as MegaMenus } from 'primereact/megamenu';  

const MegaMenu = ({...rest}) => {

    return (
        <MegaMenus {...rest} />
    )

};

export default MegaMenu;